/*
  One sideways row, shared by every section that has one — now a Fancyapps
  Carousel (the library the product gallery and the shoppers' strip already
  use) instead of our own scroll-and-drag code (user, 2026-10-13: "turim jau
  gerą lib'ą kuris out of the box turi viską … reusink visur"). The library
  does the dragging, the swipe physics, the settling on a card and the click
  that must not follow a drag; this file only connects it to our markup.

  Markup contract (unchanged, so the sections did not have to be rewritten)
    [data-rail]                 the row. Gets is-overflow / is-start / is-end,
                                and carries --rail-arrow-top when the arrows
                                are centred on a picture.
    [data-rail-track]           the element whose children are the cards. It
                                becomes the .f-carousel.
    [data-rail-prev/-next]      optional buttons. Looked for inside the row
                                first, then anywhere inside [data-rail-scope].
    data-rail-centre="<sel>"    optional. Puts the arrows at the middle of the
                                first matching element inside the track.
    data-rail-align="center"    optional. The current card stops in the middle
                                of the row with its neighbours peeking at both
                                edges (the first and last still sit at the
                                ends). The library marks it .is-selected.

  CSS contract — the stylesheet decides, per breakpoint, whether a track is a
  carousel at all, so a section that is a grid on a desktop and a row on a
  phone needs no script of its own:
    --rail: on                  on the track wherever it should be a carousel
    --rail-slide                a card's width (any length, % of the row)
    --rail-gap                  the space between cards
  nagi.css maps the last two onto the library's own variables. Where --rail is
  not "on", the track is left alone — and before this script has run, a track
  is still a plain scrolling row, so nothing is unusable while it loads.

  Carousel itself comes from fancy-carousel.js, or on a product page from
  fancybox.js, which carries the same library (loading both breaks Fancybox).
*/
(function () {
  'use strict';

  var still = window.matchMedia('(prefers-reduced-motion: reduce)');

  function wanted(track) {
    return getComputedStyle(track).getPropertyValue('--rail').trim() === 'on';
  }

  function bind(rail) {
    if (rail.nagiRail) { rail.nagiRail.apply(); return; }
    var track = rail.querySelector('[data-rail-track]');
    if (!track) return;

    var scope = rail.closest('[data-rail-scope]') || rail.closest('section') || rail;
    var prev = rail.querySelector('[data-rail-prev]') || scope.querySelector('[data-rail-prev]');
    var next = rail.querySelector('[data-rail-next]') || scope.querySelector('[data-rail-next]');
    var centreSel = rail.getAttribute('data-rail-centre');
    var car = null;

    /* Both arrows stand whenever the row has more than one stop — a pair that
       appears and disappears reads as layout shifting. The one with nothing
       behind it dims and stops answering instead. A row that fits shows
       neither. The same facts go on the row as classes, for the edge fades. */
    function sync() {
      var many = !!car && car.getPages().length > 1;
      var atStart = !car || !car.canGoPrev();
      var atEnd = !car || !car.canGoNext();
      if (prev) { prev.hidden = !many; prev.disabled = atStart; }
      if (next) { next.hidden = !many; next.disabled = atEnd; }
      rail.classList.toggle('is-overflow', many);
      rail.classList.toggle('is-start', atStart);
      rail.classList.toggle('is-end', atEnd);
    }

    /* The arrows belong on the picture, and only the browser knows how tall
       that is. Measured when the layout changes, never while the row moves. */
    function centre() {
      if (!centreSel) return;
      var media = track.querySelector(centreSel);
      if (!media) return;
      var m = media.getBoundingClientRect();
      var r = rail.getBoundingClientRect();
      if (!m.height) return;
      rail.style.setProperty('--rail-arrow-top', (m.top - r.top + m.height / 2) + 'px');
    }

    /* Cards in a row stand equally tall, as they did in a grid: the tallest
       one's natural height, measured with the floor taken off first. */
    function level() {
      if (!car) { track.style.removeProperty('--rail-h'); return; }
      track.style.setProperty('--rail-h', '0px');
      var h = 0;
      Array.prototype.forEach.call(track.querySelectorAll('.f-carousel__slide'), function (s) {
        if (s.offsetHeight > h) h = s.offsetHeight;
      });
      track.style.setProperty('--rail-h', h + 'px');
    }

    function build() {
      if (car || !window.Carousel) return;
      Array.prototype.forEach.call(track.children, function (c) { c.classList.add('f-carousel__slide'); });
      track.classList.add('f-carousel');
      car = window.Carousel(track, {
        /* One card a step, left-aligned, the last stop where the last card
           meets the edge — the way the rows behaved before. */
        slidesPerPage: 1,
        infinite: false,
        center: rail.getAttribute('data-rail-align') === 'center',
        fill: true,
        dragFree: false,
        transition: still.matches ? false : 'tween',
        on: { ready: sync, refresh: sync, change: sync, settle: sync }
      }).init();
      level();
      sync();
      centre();
    }

    function tear() {
      if (!car) return;
      car.destroy();
      car = null;
      /* destroy() leaves its viewport wrapper and the slides' marks behind;
         a row that turns back into a grid needs its cards as direct
         children again, with nothing of the carousel left on them. */
      var vp = track.querySelector(':scope > .f-carousel__viewport');
      if (vp) {
        while (vp.firstChild) track.insertBefore(vp.firstChild, vp);
        vp.remove();
      }
      track.className = track.className.replace(/\b(f-carousel|is-[a-z-]+)\b/g, '').replace(/\s+/g, ' ').trim();
      Array.prototype.forEach.call(track.children, function (c) {
        c.classList.remove('f-carousel__slide', 'is-selected');
        c.removeAttribute('index');
        c.style.removeProperty('transform');
        c.style.removeProperty('min-height');
        if (!c.getAttribute('style')) c.removeAttribute('style');
      });
      sync();
    }

    function apply() {
      if (!track.isConnected) return;
      if (wanted(track)) build(); else tear();
      level();
      centre();
    }

    if (prev) prev.addEventListener('click', function () { if (car) car.prev(); });
    if (next) next.addEventListener('click', function () { if (car) car.next(); });

    rail.nagiRail = { apply: apply, get carousel() { return car; } };
    apply();

    /* Breakpoints change whether a track is a row; a container that opens
       (the cart drawer's column grows from nothing) changes how many cards
       fit. Either way the library is told, or built, or taken down. */
    var pending = false;
    function later() {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        apply();
        sync();
      });
    }
    window.addEventListener('resize', later);
    if ('ResizeObserver' in window) new ResizeObserver(later).observe(rail);
  }

  function bindAll() {
    if (!window.Carousel) return;
    document.querySelectorAll('[data-rail]').forEach(bind);
  }

  /* The cart drawer builds its rows after this file has run, and the drawer is
     an app's, so there is no section event to hang on. It calls this once its
     rows are in the DOM; rows already bound are only re-measured. */
  window.nagiRail = { bindAll: bindAll };

  function boot() {
    if (window.Carousel) { bindAll(); return; }
    /* On a product page the library arrives with fancybox.js, which may run
       after this file. */
    window.addEventListener('load', bindAll, { once: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  /* The theme editor re-renders a section without reloading the page. */
  document.addEventListener('shopify:section:load', bindAll);
})();
